import { render, staticRenderFns } from "./1_PersonalDetails.vue?vue&type=template&id=becf9034&scoped=true&"
import script from "./1_PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./1_PersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./1_PersonalDetails.vue?vue&type=style&index=0&id=becf9034&lang=scss&scoped=true&"
import style1 from "./1_PersonalDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf9034",
  null
  
)

export default component.exports